<script setup>
defineProps({
	currentArticle: {
		type: Object,
		required: true,
	},
});
</script>

<template>
<section class="archived dialog">
	<h1>This article has been archived.</h1>
	<p>The host for this article has taken the page down. A backup of the article will be available soon.</p>
	<p>In the meantime, you can read or check a web-archive to see if there's already a backup:</p>
	<ul>
		<li>
			<a :href="'https://web.archive.org/web/20200401000000*/' + currentArticle?.url" target="_blank">
				Internet Archive
			</a>
		</li>
		<li>
			<a href="'https://archive.is/' + currentArticle?.url" target="_blank">
				Archive.is
			</a>
		</li>
	</ul>
</section>
</template>

<style lang="scss" scoped>
.dialog {
	background-color: var(--bg2);
	border: 1px solid var(--border);
	border-radius: 32px;
	box-shadow: 0 22px 49px -10px rgba(0, 0, 0, 0.03), 0 43px 60px -30px rgba(0, 0, 0, 0.06), 0 59px 41px -47px rgba(0, 0, 0, 0.05);

	padding: 24px 20px 20px;
	position: relative;
	width: clamp(220px, 70%, 500px);

	margin-top: 40px;
	margin-bottom: 10vh; // fallback
	margin-bottom: 10dvh;
}
h1 { margin: 0; }
p { margin: .75em 0; }
a { color: var(--text-warning); }
</style>
